export default "__VITE_ASSET__DkhHonQE__"